exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feedback-detail-modal[data-v-9497453a] .ant-modal-title {\n  font-size: 16px;\n  font-weight: bold;\n  color: #333;\n}\n.feedback-detail-modal[data-v-9497453a] .ant-modal-body {\n  min-height: 450px;\n  padding: 10px 24px;\n}\n", ""]);

// exports
